import { render, staticRenderFns } from "./EditContact.vue?vue&type=template&id=3d0de4fa&"
import script from "./EditContact.vue?vue&type=script&lang=js&"
export * from "./EditContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d0de4fa')) {
      api.createRecord('3d0de4fa', component.options)
    } else {
      api.reload('3d0de4fa', component.options)
    }
    module.hot.accept("./EditContact.vue?vue&type=template&id=3d0de4fa&", function () {
      api.rerender('3d0de4fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/conversation/contact/EditContact.vue"
export default component.exports